import Bottom from './Bottom';
import Home from './Home';
import Login from './Login';
import PrintStudio from './PrintStudio';
import ProtectedRoute from '../components/ProtectedRoute';
import { Route, Routes } from 'react-router-dom';

function PrintStudioRoute() {
  return (
    <ProtectedRoute>
      <PrintStudio />
    </ProtectedRoute>
  );
}

function Pages() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/print" element={<PrintStudioRoute />} />
        <Route path="/print-studio" element={<PrintStudioRoute />} />
      </Routes>
      <Bottom />
    </div>
  );
}

export default Pages;
